import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { ConfirmModal, DataView, LoadingComponent, LoadingButton, ToastsContainer, ContentModal } from 'usbc-web-react-library'
import useDashboardApi from '../../../hooks/useDashboardApi'
import SupplyItem from '../SupplyItem/SupplyItem'
import './SupplyList.css'
import OrderStatusPill from '../../shared/OrderStatusPill/OrderStatusPill';
import react from 'react';
import OrderEditForm from '../../Orders/OrderList/OrderEditForm/OrderEditForm';
import OrderDetailsView from '../../Orders/OrderList/OrderDetailsView/OrderDetailsView';
import GlobalContext from '../../../store/global-context';

let requestData = {};

function SupplyList() {

    let { orderId, orderName, orderStatus } = useParams();
    const [showConfirmSubmit, setShowConfirmSubmit] = useState(false);
    const [showConfirmCancel, setShowConfirmCancel] = useState(false);
    const [toasts, setToastsState] = useState([]);
    const [ostatus, setostatus] = useState(orderStatus);
    const [oname, setoname] = useState(orderName);
    const [oid, setoid] = useState(orderId);
    const [orderToAction, setOrderToAction] = useState(null);
    const [confirmShipping, setConfirmShipping] = useState(false);
    const [showEditOrder, setShowEditOrder] = useState(false);
    const [shippingButtonClicked, setShippingButtonClicked] = useState(false);
    const [orderLoading, setOrderLoading] = useState(false);
    const globalCtx = useContext(GlobalContext);
    const hasCurrentSeasonSubmittedOrder = globalCtx.hasCurrentSeasonSubmittedOrder;
    let navigate = useNavigate();

    const {
        submitOrder,
        response: submitOrderResult,
        loading: submitOrderLoading
    } = useDashboardApi();

    const {
        saveOrderForEdit,
        response: saveOrderResult,
        loading: saveOrderLoading
    } = useDashboardApi();
    const {
        cancelOrder,
        response: cancelOrderResult,
        loading: cancelOrderLoading
    } = useDashboardApi();

    const {
        hasPermission,
        response: hasPermissionResult,
        loading: permissionLoading,
        setResponse: setPermissionResult
    } = useDashboardApi();

    function onSubmitOrder() {
        submitOrder().then(data => {
            onOrderSubmitted();

        });
    }

    function onCancelOrder() {
        cancelOrder().then(data => {
            onOrderCanceled();
        });
    }


    const {
        getSuppliesService,
        response: suppliesResult,
        loading: suppliesLoading,
        setResponse: setSuppliesResult
    } = useDashboardApi();

    useEffect(() => {
        getSupplies({
            id: oid
        });
        hasPermission(["CanChangeQuantity"]);
    }, []);

    function getSupplies() {
        let id = ostatus === "Incomplete" ? 0 : oid;
        let body = {
            orderId: id,
            paging: { ...requestData.pagingInfo },
            ...requestData.filterInfo
        };

        getSuppliesService(body);
    }

    function onOrderSubmitted() {
        navigate("/SupplyOrder");
    }

    function onOrderCanceled() {
        pushToToasts(`Order canceled`, 'success');
        navigate("/SupplyOrder");
    }
    function updateSupplyQuantity(index, value) {
        let temp = suppliesResult;
        temp.order.supplies[index].qtyApproved = value;
        setSuppliesResult(temp);
    }
    function updateSupplyNotes(index, value) {
        let temp = suppliesResult;
        temp.order.supplies[index].notes = value;
        setSuppliesResult(temp);
    }
    function supplyItemTemplate(item, index, layout) {
        return <SupplyItem item={item} index={index} layout={layout} orderStatus={ostatus}
            hasEditPermission={hasPermissionResult && hasPermissionResult["CanChangeQuantity"]}
            ostatus={ostatus}
            setQuantity={(value) => updateSupplyQuantity(index, value)}
            setNotes={(value) => updateSupplyNotes(index, value)}

        />
    }
    function headerTemplate(layout) {
        return <tr>

            {hasPermissionResult && hasPermissionResult["CanChangeQuantity"] ?
                <>
                    <th scope="col">Supply Item</th>
                    <th scope="col">Recommended Quantity</th>
                    <th scope="col">Remaining Quantity</th>
                    <th scope="col">All</th>
                    <th scope="col">Approved Quantity</th>
                    <th scope="col">Notes</th>
                </>
                : <>
                    <th scope="col">Supply Item</th>
                    <th scope="col">Order Quantity</th>
                </>}
        </tr>;
    }


    function onSubmitConfirmHandler() {
        let order = { id: oid };
        setOrderToAction(order);
        setConfirmShipping(true);
        setShowEditOrder(true);
        setShowConfirmSubmit(false);
    }
    function onShippingClicked() {
        let order = { id: oid };
        setOrderToAction(order);
        setConfirmShipping(true);
        setShippingButtonClicked(true);
        setShowEditOrder(true);
    }
    function onShippingConfirmed() {
        setShowEditOrder(false);
        setConfirmShipping(false);
        if (!shippingButtonClicked) {
            if (hasPermissionResult && hasPermissionResult["CanChangeQuantity"])
                saveOrderForEdit(suppliesResult.order).then(x => onSubmitOrder());
            else
                onSubmitOrder();
        }
        setShippingButtonClicked(false);
    }
    function onCancelConfirmHandler(order) {
        setShowConfirmCancel(false);
        onCancelOrder();
    }

    function pushToToasts(message, type) {
        setToastsState((prev) => { return [...prev, { type: type, text: message }] });
    }
    function onSaveOrderClicked() {
        saveOrderForEdit(suppliesResult.order).then(x => pushToToasts("Quantites Updated", 'success'));
    }
    function notifications() {
        if (ostatus === "Incomplete") {
            return <div className="alert alert-warning d-flex align-items-center px-2 py-1" role="alert">
                <i className="bi bi-exclamation-triangle me-2 notifications-icon" ></i>
                <div>
                    <b>Please note:</b> If any quantities on the incomplete order need to be different,
                    please <span className="emphasized">STOP</span> and email{' '}
                    <a href="mailto:supplyorders@bowl.com" target="_blank>supplyorders@bowl.com">supplyorders@bowl.com</a>,{' '}
                    <span className="emphasized">DO NOT</span> submit the order.
                    <br />
                    Please be sure to verify your supply orders as soon as they are received.  While we understand
                    that mistakes happen, we need to make sure that the orders are correct when they
                    are received so that we can correct any inventory issues immediately and send the correct items right out.
                    Please contact us within <span className="emphasized">30 days of receiving your shipment</span> with any errors
                    or we will assume your order is correct and was received in full.
                </div>
            </div>
        } else if (suppliesResult?.order?.isCurrentSeasonOrder) {
            return <div className="alert alert-info d-flex align-items-center px-2 py-1" role="alert">
                <i className="bi bi-info-square me-2 notifications-icon" ></i>
                <div>
                    An order has been submitted for the current season.  If you want any changes for that order, please email{' '}
                    <a href="mailto:supplyorders@bowl.com" target="_blank>supplyorders@bowl.com">supplyorders@bowl.com</a>.
                </div>
            </div>
        }
    }
    function controlButtons() {
        if (ostatus === "Incomplete") {
            return <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button"
                    className="btn btn-success bg-usbc-green me-md-1"
                    onClick={() => onShippingClicked()}>
                    <i className="bi bi-truck" />
                    <span className="ms-2">Show Shipping Info</span>
                </button>
                <div className={hasCurrentSeasonSubmittedOrder ? 'tooltip-container' : ""}>
                    <LoadingButton type="button"
                        className="btn btn-success bg-usbc-green me-md-1"
                        loadingText='Submitting Order'
                        loading={submitOrderLoading || orderLoading}
                        disabled={hasCurrentSeasonSubmittedOrder}
                        onClick={() => setShowConfirmSubmit(true)}>
                        <i className="bi bi-save" />
                        <span className="ms-2">{hasPermissionResult && hasPermissionResult["CanChangeQuantity"] ? "Save & Submit Order" : "Submit Order"}</span>
                        {hasCurrentSeasonSubmittedOrder &&
                            <div>
                                <span className="tooltip-text">Please wait for the existing Submitted order to be Completed</span>
                            </div>}
                    </LoadingButton>
                </div>
                <LoadingButton type="button"
                    className="btn btn-primary"
                    loadingText='Cancelling Order'
                    loading={cancelOrderLoading}
                    onClick={() => setShowConfirmCancel(true)}>
                    <i className="bi bi-x-circle" />
                    <span className="ms-2">Cancel Order</span>
                </LoadingButton>
            </div>
        }
        else {
            return <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button"
                    className="btn btn-success bg-usbc-green me-md-1"
                    onClick={() => onShippingClicked()}>
                    <i className="bi bi-truck" />
                    <span className="ms-2">Show Shipping Info</span>
                </button>
            </div>
        }
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <p className="mb-0 d-flex align-items-center">
                    <OrderStatusPill status={ostatus} />
                </p>
                {
                    (ostatus != "Incomplete" && suppliesLoading != true) ?
                        <>
                            <p className="mb-0 d-flex align-items-center">
                                <span className='order-title'>Order Date:</span>&nbsp;{suppliesResult?.order?.orderDate}
                            </p>
                            <p className="mb-0 d-flex align-items-center">
                                <span className='order-title'>Ordered By:</span>&nbsp;{suppliesResult?.order?.createdBy}
                            </p>
                        </>

                        : ""
                }
                {
                    (ostatus != "Incomplete" && suppliesLoading != true && suppliesResult?.order?.shipDate) ?
                        <>
                            <p className="mb-0 d-flex align-items-center">
                                <span className='order-title'>Shipped Date</span>&nbsp;{suppliesResult?.order?.shipDate}
                            </p>
                        </>
                        : ""
                }
                {controlButtons()}

            </div>
            <LoadingComponent isLoading={() => suppliesLoading === true || permissionLoading === true} description='Loading supplies'>
                <DataView data={suppliesResult?.order.supplies}
                    itemTemplate={supplyItemTemplate}
                    headerTemplate={headerTemplate}
                    defaultLayout={4}
                    hideLayoutSwitch={true}
                    emptyText="No Supplies Found"
                    middleArea={notifications}
                />
                {ostatus == "Incomplete" && hasPermissionResult && hasPermissionResult["CanChangeQuantity"] ?
                    <LoadingButton type="button"
                        className="btn btn-primary float-end"
                        loadingText='Saving quantites'
                        loading={saveOrderLoading}
                        onClick={() => onSaveOrderClicked()}>
                        <i className="bi bi-x-save" />
                        <span className="ms-2">Save For Later</span>
                    </LoadingButton> : ""}
            </LoadingComponent>

            {
                (showConfirmSubmit === true) &&
                <ConfirmModal
                    show={showConfirmSubmit}
                    modelHide={() => setShowConfirmSubmit(false)}
                    question="Do you want to submit the order?"
                    yesHandler={() => onSubmitConfirmHandler()}
                    noHandler={() => setShowConfirmSubmit(false)}>
                </ConfirmModal>
            }
            {
                (showConfirmCancel === true) &&
                <ConfirmModal
                    show={showConfirmCancel}
                    modelHide={() => setShowConfirmCancel(false)}
                    question="Do you want to cancel the order?"
                    yesHandler={() => onCancelConfirmHandler()}
                    noHandler={() => setShowConfirmCancel(false)}>
                </ConfirmModal>
            }
            {
                (showEditOrder === true && confirmShipping) &&
                <ContentModal show={showEditOrder}
                    icon={<i className="bi bi-clipboard me-2 content-modal-icon"></i>}
                    title='Confirm Shipping' modelHide={() => setShowEditOrder(false)}
                    showClose={true} size="modal-lg">
                    <OrderEditForm onOrderSaved={onShippingConfirmed} onCancel={() => setShowEditOrder(false)} order={orderToAction} />
                </ContentModal>
            }
            {
                (showEditOrder === true && !!orderToAction && (orderToAction.status === 'Submitted' || orderToAction.status === 'Completed')) &&
                <ContentModal show={showEditOrder}
                    icon={<i className="bi bi-clipboard me-2 content-modal-icon"></i>}
                    title='View Order' modelHide={() => setShowEditOrder(false)}
                    showClose={true} size="modal-lg">
                    <OrderDetailsView onCancel={() => setShowEditOrder(false)} order={orderToAction} />
                </ContentModal>
            }
            <ToastsContainer toasts={toasts} />

        </>
    )
}

export default SupplyList